/* eslint-disable */

// ⇘⇘⇘⇘⇘⇘⇘   ⇓ ⇓ ⇓ ⇓ ⇓  ⇙⇙⇙⇙⇙⇙⇙⇙
// ⇒ ⇒ ⇒ ⇒ ⇒ *R*E*A*C*T* ⇐ ⇐ ⇐ ⇐
// ⇗⇗⇗⇗⇗⇗⇗   ⇑ ⇑ ⇑ ⇑ ⇑  ⇖⇖⇖⇖⇖⇖⇖⇖

import React, { useState } from 'react';

import { Card, Form, Button, Spinner } from 'react-bootstrap';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
import { updateDato, richiediQualificaSingola } from '../funzioni';

const Modifica = ({ descrizione, tipo, valore, modificabile, idDato, formatoData, possibleAnswers, attach }) => {
  const states = {
    LOADING: 'loading',
    ACTIVE: 'active',
    DISABLED: 'disabled',
    SAVE: 'save',
  };

  const [buttonState, setButtonState] = useState(modificabile ? states.ACTIVE : states.DISABLED);
  const [modifica, setModifica] = useState(false);
  const [valoreInput, setValoreInput] = useState(
    formatoData && valore
      ? valore
          .split('/')
          .reverse()
          .map((i, inn) => (i.length < 2 ? `0${i}` : i)) // metto uno 0 prima del mese se è a una cifra (gennaio) 1 => 01
          .join('-')
      : valore
  );

  React.useEffect(() => {
    setValoreInput(
      formatoData && valore
        ? valore
            .split('/')
            .reverse()
            .map((i, inn) => (i.length < 2 ? `0${i}` : i)) // metto uno 0 prima del mese se è a una cifra (gennaio) 1 => 01
            .join('-')
        : valore
    );
  }, [valore]);

  const handleButtonClick = () => {
    switch (buttonState) {
      case states.ACTIVE:
        setModifica(true);
        setButtonState(states.SAVE);
        break;

      case states.SAVE:
        setModifica(false);
        updateDato(
          () => setButtonState(states.LOADING),
          async () => {
            const d = await richiediQualificaSingola(idDato);
            if (d) {
              setValoreInput(d);
            }
            setButtonState(states.ACTIVE);
          },
          () => setButtonState(states.ACTIVE),
          idDato,
          formatoData ? new Date(valoreInput).toLocaleDateString('it-It', { day: '2-digit', month: '2-digit', year: 'numeric' }) : valoreInput,
          'dato'
        );
        break;
      default:
        break;
    }
  };

  const getIcon = () => {
    switch (buttonState) {
      case states.ACTIVE:
        return 'edit';
      case states.DISABLED:
        return 'edit';
      case states.SAVE:
        return 'save';
      default:
        return '';
    }
  };

  return (
    <Card border className="border-primary h-100">
      <Card.Header className="p-3 h-100 d-flex flex-column align-items-start justify-content-center">
        <Card.Title className="m-0 w-100">{descrizione}</Card.Title>
        {attach && (
          <a href={attach} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-sm mt-2">
            Download guidelines
          </a>
        )}
      </Card.Header>
      <Card.Body className="d-flex flex-column justify-content-center" style={{ height: 100 }}>
        <div className="d-flex">
          {possibleAnswers ? (
            <select
              className="form-select"
              onChange={(e) => {
                setValoreInput(e.target.value);
              }}
              disabled={!modifica}
              value={valoreInput || ''}
            >
              <option value="">Select answer</option>
              {possibleAnswers?.split('/').map((r, i) => {
                return (
                  <option key={r} value={r}>
                    {r}
                  </option>
                );
              })}
            </select>
          ) : (
            <Form.Control
              type={tipo}
              value={valoreInput}
              onChange={(e) => {
                setValoreInput(e.target.value);
              }}
              maxLength={tipo === 'text' ? 250 : null}
              disabled={!modifica}
            />
          )}
          <Button className="ms-3" disabled={buttonState === states.DISABLED} onClick={handleButtonClick}>
            {buttonState === states.LOADING ? <Spinner animation="border" size="sm" /> : <CsLineIcons icon={getIcon()} />}
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default Modifica;
